export default __webpack_public_path__ + "static/media/logo.341db5d8.svg";